export function aboutSlide() {

const aboutBigSliders = document.querySelectorAll('.js-aboutSpBig');
aboutBigSliders.forEach((el) => {
  new Swiper(el, {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    allowTouchMove: false, // 操作不可
    slidesPerView: 1,
    spaceBetween: 0,
	speed: 1000
  });
});

const aboutSmallSliders = document.querySelectorAll('.js-aboutSpSmall');
aboutSmallSliders.forEach((el) => {
  new Swiper(el, {
    loop: true,
	// effect: "fade",
    autoplay: {
    //   delay: 4500,
      delay: 4000,
      disableOnInteraction: false
    },
    allowTouchMove: false, // 操作不可
    slidesPerView: 1,
    spaceBetween: 0,
	// speed: 500
	speed: 1000
  });
});
}